<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M26.87 23.5l-3.58-6.25a9 9 0 10-14.58 0L5.13 23.5a1 1 0 000 1A1 1 0 006 25h4.5l2.7 3.6a1 1 0 00.8.4h.09a1 1 0 00.8-.55L16 26.24l1.11 2.21a1 1 0 00.8.55H18a1 1 0 00.8-.4l2.7-3.6H26a1 1 0 00.86-.5 1 1 0 00.01-1zM16 5a7 7 0 11-7 7 7 7 0 017-7zm-2.17 21.11l-2-2.71A1 1 0 0011 23H7.72l2.4-4.2a9 9 0 003 1.73L14.88 24zM21 23a1 1 0 00-.8.4l-2 2.71L15.61 21H16a8.94 8.94 0 005.88-2.2l2.4 4.2z"/><path d="M14.79 15.21a1 1 0 001.42 0l4.5-4.5a1 1 0 00-1.42-1.42l-3.79 3.8-2.29-2.3a1 1 0 00-1.42 1.42z"/></svg>